import {
  OpensearchPaginationCursorSchema,
  SortDirection,
} from "@redotech/redo-model/tables/table";
import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
  VALID_PAGE_SIZES,
} from "@redotech/redo-model/views/views";
import { StorageLocationTableRowSchema } from "@redotech/redo-model/wms/schema/storage-location";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getStorageLocations = {
  name: "getStorageLocations" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z
      .number()
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    search: z.string().nullish(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
    includeZeroQuantity: z.boolean().optional(),
  }),
  output: z.object({
    storageLocations: z.array(StorageLocationTableRowSchema),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};
